import { Flex, Stepper } from '@servicetitan/anvil2';
import { ImperativeForm } from '@servicetitan/financing-application-shared';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { RefObject, useCallback } from 'react';

interface PrequalificationButtonsProps {
    formRef: RefObject<ImperativeForm>;
    isNextButtonDisabled?: boolean;
    customFinalStepTitle?: string;
}

export const PrequalificationButtons = ({
    formRef,
    isNextButtonDisabled = false,
    customFinalStepTitle,
}: PrequalificationButtonsProps) => {
    const nextHandler = useCallback(async () => {
        // Prefer submit()'s return value over isValid() — formState.isValid can
        // briefly report stale true for untouched required fields after handleSubmit.
        const isValid = await formRef.current?.submit();
        return isValid ?? true;
    }, [formRef]);

    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();

    return (
        <Flex justifyContent="space-between" style={{ width: '100%' }} gap="4">
            <Flex gap="3" justifyContent="flex-end" grow={1} style={{ width: '100%' }}>
                <Stepper.PrevButton label="Back" />
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                <Stepper.NextButton
                    nextLabel="Continue"
                    completeLabel={customFinalStepTitle ?? 'Continue'}
                    disabled={isNextButtonDisabled}
                    onClick={nextHandler as unknown as () => void}
                    style={customFinalStepTitle ? { width: '100%' } : undefined}
                />
            </Flex>
        </Flex>
    );
};
